// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-b6882f28],td[data-v-b6882f28],th[data-v-b6882f28]{border:1px solid #000;border-collapse:collapse;text-align:center}table[data-v-b6882f28]{width:100%}pre[data-v-b6882f28]{overflow-x:scroll}", ""]);
// Exports
module.exports = exports;
